import { Question } from '../types';

const questions: Question[] = [
  {
    id: 1,
    title: "Qual é seu cargo atual?",
    type: "single",
    options: [
      { id: "junior", label: "Analista Fiscal Júnior" },
      { id: "pleno", label: "Analista Fiscal Pleno" },
      { id: "senior", label: "Analista Fiscal Sênior" },
      { id: "coord", label: "Coordenador Fiscal" },
      { id: "financeiro", label: "Analista Financeiro" },
      { id: "outro", label: "Outro" }
    ]
  },
  {
    id: 2,
    title: "Qual o volume de notas fiscais emitidas por mês?",
    type: "single",
    weight: 3,
    options: [
      { id: "up_to_100", label: "Até 100", value: 1 },
      { id: "100_to_500", label: "De 100 a 500", value: 2 },
      { id: "500_to_1000", label: "De 500 a 1000", value: 3 },
      { id: "1000_to_5000", label: "De 1000 a 5000", value: 4 },
      { id: "more_than_5000", label: "Mais de 5000", value: 5 }
    ]
  },
  {
    id: 3,
    title: "Com que frequência você precisa corrigir erros em notas fiscais?",
    type: "single",
    weight: 3,
    options: [
      { id: "rare", label: "Raramente (1-2 vezes por mês)", value: 1 },
      { id: "occasional", label: "Ocasionalmente (1x por semana)", value: 2 },
      { id: "frequent", label: "Frequentemente (várias vezes por semana)", value: 3 },
      { id: "daily", label: "Diariamente", value: 4 }
    ]
  },
  {
    id: 4,
    title: "Quantos sistemas diferentes você acessa diariamente para gerenciar documentos fiscais?",
    type: "single",
    weight: 2,
    options: [
      { id: "1_2", label: "1-2 sistemas", value: 1 },
      { id: "3_4", label: "3-4 sistemas", value: 2 },
      { id: "5_6", label: "5-6 sistemas", value: 3 },
      { id: "more_6", label: "Mais de 6 sistemas", value: 4 }
    ]
  },
  {
    id: 5,
    title: "Com quantas prefeituras diferentes sua empresa precisa lidar?",
    type: "single",
    weight: 2,
    options: [
      { id: "1_5", label: "1-5 prefeituras", value: 1 },
      { id: "6_15", label: "6-15 prefeituras", value: 2 },
      { id: "16_30", label: "16-30 prefeituras", value: 3 },
      { id: "more_30", label: "Mais de 30 prefeituras", value: 4 }
    ]
  },
  {
    id: 6,
    title: "Com que frequência você trabalha sob pressão de prazos fiscais?",
    type: "single",
    weight: 2,
    options: [
      { id: "rare", label: "Raramente", value: 1 },
      { id: "monthly", label: "Mensalmente", value: 2 },
      { id: "weekly", label: "Semanalmente", value: 3 },
      { id: "daily", label: "Diariamente", value: 4 }
    ]
  },
  {
    id: 7,
    title: "Quanto tempo por semana você gasta em alinhamentos com o contador/contabilidade?",
    type: "single",
    weight: 1,
    options: [
      { id: "less_2", label: "Menos de 2 horas", value: 1 },
      { id: "2_5", label: "2-5 horas", value: 2 },
      { id: "5_10", label: "5-10 horas", value: 3 },
      { id: "more_10", label: "Mais de 10 horas", value: 4 }
    ]
  },
  {
    id: 8,
    title: "Quais dessas atividades você realiza manualmente hoje?",
    type: "multiple",
    weight: 3,
    options: [
      { id: "download", label: "Download de XMLs de múltiplos portais" },
      { id: "typing", label: "Digitação/redigitação de dados" },
      { id: "check", label: "Conferência manual linha por linha" },
      { id: "classification", label: "Classificação contábil manual" },
      { id: "send", label: "Envio manual para contabilidade" },
      { id: "organize", label: "Organização e arquivo de documentos" },
      { id: "deadlines", label: "Controle de prazos em planilhas" }
    ]
  },
  {
    id: 9,
    title: "Quando ocorrem erros fiscais, qual o impacto na sua rotina?",
    type: "single",
    weight: 3,
    options: [
      { id: "low", label: "Baixo - Resolvo em poucos minutos", value: 1 },
      { id: "medium", label: "Médio - Algumas horas de retrabalho", value: 2 },
      { id: "high", label: "Alto - Um dia inteiro perdido", value: 3 },
      { id: "critical", label: "Crítico - Vários dias e envolve outras áreas", value: 4 }
    ]
  },
  {
    id: 10,
    title: "Se você tivesse 40% mais tempo livre, o que gostaria de fazer?",
    type: "multiple",
    weight: 0,
    options: [
      { id: "analysis", label: "Análises estratégicas e relatórios gerenciais" },
      { id: "improvement", label: "Projetos de melhoria de processos" },
      { id: "skills", label: "Desenvolvimento de novas habilidades" },
      { id: "support", label: "Suporte consultivo a outras áreas" },
      { id: "planning", label: "Planejamento tributário" },
      { id: "study", label: "Estudar e me certificar" }
    ]
  }
];

export default questions;